//#region ../src/utils/qr-payload/utf8.ts
/**
* UTF-8 helpers shared by the QR payload codecs (benchmark plan §6 P3).
* Decoding is TOTAL: invalid byte sequences yield `null` (fatal
* `TextDecoder`, exception swallowed) — never a lossy U+FFFD substitution,
* because a silently mangled payload is worse than a rejected one.
*/
const ENCODER = new TextEncoder();
const FATAL_DECODER = new TextDecoder("utf-8", {
	fatal: true,
	ignoreBOM: true
});
function utf8Encode(text) {
	return ENCODER.encode(text);
}
/** Decode UTF-8 bytes, or `null` when the sequence is invalid. */
function utf8DecodeTotal(bytes) {
	try {
		return FATAL_DECODER.decode(bytes);
	} catch {
		return null;
	}
}
//#endregion
export { utf8Encode as n, utf8DecodeTotal as t };
